var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-clock",style:(_vm.clockStyle)},[_c('span',{staticClass:"live-clock-text text-secondary",style:(_vm.clockTextStyle)},[_vm._v(_vm._s(_vm.clockDisplay))])])
}
var staticRenderFns = []

export { render, staticRenderFns }